/* theme-ajax-cart — cart drawer (no Liquid; uses window.TCN_THEME from theme-runtime-config) */
function tcnAjaxCartMoneyFormat() {
  return (window.ajaxCartConfig && window.ajaxCartConfig.moneyFormat) ||
    (window.TCN_THEME && window.TCN_THEME.moneyFormat) ||
    null;
}

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : null,
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    // Always set up form override (even if no buttons found initially) to catch dynamically added forms
    if (!settings.disableAjaxCart) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.js-number-cart').removeClass('active');
      }
    }
    if ($cartCostSelector) {
      // Use shop's money format (same logic as cartDrawerTotalPrice)
      var moneyFormat = tcnAjaxCartMoneyFormat();
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, moneyFormat));
    }
  };

  formOverride = function () {
    // Use event delegation on document to catch all forms, including dynamically added ones
    $(document).off('submit', settings.formSelector).on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      
      var $form = $(this);
      var $addToCart_btn = $form.find(settings.addToCartSelector);
      
      // Check if button exists
      if ($addToCart_btn.length === 0) {
        console.warn('Add to cart button not found in form');
        return false;
      }
      
      // Add class to be styled if desired
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      // Check if ShopifyAPI is available
      if (typeof ShopifyAPI === 'undefined' || typeof ShopifyAPI.addItemFromForm !== 'function') {
        console.error('ShopifyAPI.addItemFromForm not available');
        // Fallback: allow form to submit normally
        return true;
      }

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
      return false;
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html('<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>');

    // Update cart drawer with added item
    // The product object from add to cart has: title, price, quantity, image, variant_id, product_id
    var productTitle = product.product_title || product.title || '';
    $('#cartDrawerItemTitle').html(productTitle);
    
    // Get correct money format - always use shop's money format
    var moneyFormat = tcnAjaxCartMoneyFormat();
    var formattedPrice = Shopify.formatMoney(product.price, moneyFormat);
$('#cartDrawerItemPrice').html(formattedPrice);
    $('#cartDrawerItemQty').html(product.quantity);
    
    // Get product image - format it properly
    var productImage = product.image || '';
    if (productImage) {
      // Ensure image URL is properly formatted
      if (productImage.indexOf('//') === 0) {
        productImage = 'https:' + productImage;
      } else if (productImage.indexOf('http') !== 0) {
        productImage = 'https:' + productImage;
      }
      $('#cartDrawerItemImage').attr('src', productImage).attr('alt', productTitle);
    }
    
    // Get variant title - will be populated from cart data after cart loads
    $('#cartDrawerItemVariant').hide();
    
    // Show the recently added item section
    $('#cartDrawerItem').show();
    
    // Update drawer title to "Added to cart" when product is added
    $('#cartDrawerTitle').text('Added to cart');

    // Open cart drawer - try multiple methods
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else if (typeof openCartDrawer === 'function') {
      openCartDrawer();
    } else {
      // Fallback: manually open drawer
      var $drawer = $('#cartDrawer');
      var $overlay = $('#cartDrawerOverlay');
      var $body = $('body');
      
      if ($drawer.length > 0) {
        $drawer.addClass('active');
        $overlay.addClass('active');
        $body.addClass('cart-drawer-open').css('overflow', 'hidden');
        $drawer.attr('tabindex', '-1').focus();
      } else {
        console.error('Cart drawer #cartDrawer not found in DOM');
      }
    }

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    $addToCart.find('.enj-loader-add-to-cart').remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Check if cart container exists
    if ($cartContainer.length === 0) {
      console.error('Cart container #CartContainer not found');
      return;
    }
    
    // Check if Handlebars template exists
    if (!$("#CartTemplate").length) {
      console.error('Cart template #CartTemplate not found. Please ensure ajax-cart-template.liquid is included in the theme.');
      // Try to wait a bit and check again (in case template is loading)
      var retryCount = 0;
      var checkTemplate = setInterval(function() {
        retryCount++;
        if ($("#CartTemplate").length) {
          clearInterval(checkTemplate);
          // Retry building cart now that template is available
          buildCart(cart);
        } else if (retryCount >= 5) {
          clearInterval(checkTemplate);
          console.error('Cart template #CartTemplate still not found after retries');
          var $cartContainer = $('#CartContainer');
          if ($cartContainer.length > 0) {
            $cartContainer.html('<p style="padding: 40px 28px; text-align: center; color: #6B6B6B;">Error: Cart template not available. Please refresh the page.</p>');
          }
        }
      }, 200);
      return;
    }
    
    // Start with a fresh cart div
    $cartContainer.empty();
    
    // Hide recently added item section when viewing full cart
    $('#cartDrawerItem').hide();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
      .append('<p style="padding: 40px 28px; text-align: center; color: rgba(43, 43, 43, 0.65);">' + ((window.TCN_THEME && window.TCN_THEME.strings && window.TCN_THEME.strings.cartEmpty) || 'Your cart is currently empty.') + '</p>');
      cartCallback(cart);
      $('.js-number-cart').removeClass('active');
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html();
    
    if (!source) {
      console.error('Cart template source is empty');
      $cartContainer.html('<p style="padding: 40px 28px; text-align: center; color: rgba(43, 43, 43, 0.65);">Error loading cart template</p>');
      return;
    }
    
    var template = Handlebars.compile(source);

    // Get correct money format - always use shop's money format
    var moneyFormat = tcnAjaxCartMoneyFormat();
    
    // Debug: Log the money format being used
// Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, moneyFormat)
    }
    
    // Update cart drawer total - use the same moneyFormat already set above
    var formattedTotal = Shopify.formatMoney(cart.total_price, moneyFormat);
$('#cartDrawerTotalPrice').html(formattedTotal);
    
    // Update recently added item variant if it's the first item
    if (cart.items.length > 0) {
      var firstItem = cart.items[0];
      var variantText = '';
      if (firstItem.variant_title && firstItem.variant_title !== 'Default Title') {
        variantText = firstItem.variant_title;
      } else if (firstItem.properties) {
        var props = [];
        for (var key in firstItem.properties) {
          if (firstItem.properties[key] && firstItem.properties[key] !== '') {
            props.push(firstItem.properties[key]);
          }
        }
        if (props.length > 0) {
          variantText = props.join(' / ');
        }
      }
      if (variantText) {
        $('#cartDrawerItemVariant').html(variantText).show();
      }
    }

    // Render the template with error handling
    try {
      var renderedHtml = template(data);
      if (!renderedHtml || renderedHtml.trim() === '') {
        console.error('Cart template rendered empty HTML. Cart items:', cart.items.length);
        $cartContainer.html('<p style="padding: 40px 28px; text-align: center; color: rgba(43, 43, 43, 0.65);">Error rendering cart items</p>');
        return;
      }
      $cartContainer.append(renderedHtml);

    } catch (error) {
      console.error('Error rendering cart template:', error);
      $cartContainer.html('<p style="padding: 40px 28px; text-align: center; color: rgba(43, 43, 43, 0.65);">Error: ' + error.message + '</p>');
      return;
    }
    
    // Function to ensure visibility - call immediately and after a delay
    function ensureCartVisibility() {
      // Ensure cart container itself is visible using attr style for !important
      $cartContainer.attr('style', 'display: block !important; visibility: visible !important; opacity: 1 !important; height: auto !important;');
      
      // Ensure cart items are visible after rendering
      $cartContainer.find('.minicart_item').each(function() {
        $(this).attr('style', 'display: block !important; visibility: visible !important; opacity: 1 !important;');
      });
      
      $cartContainer.find('.minicart_item li').each(function() {
        if (!$(this).hasClass('is-removed')) {
          $(this).attr('style', 'display: flex !important; visibility: visible !important; opacity: 1 !important;');
        }
      });
      
      // Ensure all product elements are visible
      $cartContainer.find('.prod, .product-cart').each(function() {
        $(this).attr('style', 'display: block !important; visibility: visible !important; opacity: 1 !important;');
      });
      
      $cartContainer.find('.thumb_img_cartmini, .product-detail, .product_name_mini, .product_info, .product_price').each(function() {
        $(this).attr('style', 'display: block !important; visibility: visible !important; opacity: 1 !important;');
      });
      
      $cartContainer.find('.produc_remove').each(function() {
        $(this).attr('style', 'display: flex !important; visibility: visible !important; opacity: 1 !important;');
      });
      
      // Remove any classes that might hide content (except is-removed)
      $cartContainer.find('*').not('.is-removed').removeClass('is-loading');
    }
    
    // Ensure visibility immediately
    ensureCartVisibility();
    
    // Ensure visibility after a short delay (in case something else is hiding it)
    setTimeout(function() {
      ensureCartVisibility();
    }, 100);
    
    // Also ensure visibility after a longer delay
    setTimeout(function() {
      ensureCartVisibility();
    }, 500);

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    /**
     * Remove item handler with event delegation
     * Works for dynamically injected drawer markup and on /cart page
     */
    function handleRemoveItem(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var $el = $(this);
      
      // Get line number from data-line attribute (try multiple methods)
      var line = $el.attr('data-line');
      if (!line) {
        line = $el.data('line');
      }
      if (!line) {
        // Try to get from parent elements
        line = $el.closest('li').attr('data-line') || $el.closest('li').data('line');
      }
      // Try to get from href if it's a cart page link
      if (!line && $el.attr('href')) {
        var hrefMatch = $el.attr('href').match(/line=(\d+)/);
        if (hrefMatch) {
          line = hrefMatch[1];
        }
      }
      
      // Convert to number if it's a string
      if (line) {
        line = parseInt(line, 10);
        if (!isNaN(line) && line > 0) {
          // Find the row to fade out
          var $row = $('.remove-product[data-line="' + line + '"]').closest('li');
          if ($row.length === 0) {
            $row = $('.remove-product[data-line="' + line + '"]').closest('.minicart_item li');
          }
          
          // Add loading state
          if ($row.length > 0) {
            $row.addClass('is-loading is-removed');
            $row.fadeOut(200);
          }
          
          // Use fetch API to remove item (works on /cart page too)
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              line: line,
              quantity: 0
            })
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {
            // Update cart count and total
            updateCountPrice(cart);
            
            // Update cart drawer total - always use shop's money format
            var moneyFormat = tcnAjaxCartMoneyFormat();
            var formattedTotal = Shopify.formatMoney(cart.total_price, moneyFormat);
if (cart.item_count > 0) {
              $('#cartDrawerTotalPrice').html(formattedTotal);
            } else {
              $('#cartDrawerTotalPrice').html(Shopify.formatMoney(0, moneyFormat));
            }
            
            // Reload cart drawer contents
            if (typeof buildCart === 'function') {
              buildCart(cart);
            } else {
              // Fallback: reload the cart via ShopifyAPI
              ShopifyAPI.getCart(function(updatedCart) {
                if (typeof buildCart === 'function') {
                  buildCart(updatedCart);
                }
              });
            }
            
            // If on /cart page, reload the page to update the cart table
            if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
              setTimeout(function() {
                window.location.reload();
              }, 300);
            }
          })
          .catch(function(error) {
            console.error('Error removing item:', error);
            // Restore row if error
            if ($row.length > 0) {
              $row.removeClass('is-loading is-removed').show();
            }
          });
        } else {
          console.warn('Invalid line number for remove:', line, $el);
        }
      } else {
        console.warn('No line number found on remove button:', $el);
      }
      
      return false;
    }
    
    // Use event delegation on document to catch dynamically added elements
    // This ensures it works even after drawer content is re-rendered via AJAX
    $(document).on('click', '.remove-product', handleRemoveItem);
    
    // Also handle clicks on the remove-text span (child element)
    $(document).on('click', '.remove-text', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Trigger click on parent remove-product link
      var $parent = $(this).closest('.remove-product');
      if ($parent.length > 0) {
        handleRemoveItem.call($parent[0], e);
      }
      return false;
    });
    
    // Also handle touch events for mobile
    $(document).on('touchend', '.remove-product', function(e) {
      e.preventDefault();
      handleRemoveItem.call(this, e);
      return false;
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      // Support both old structure (.ajaxcart__row) and new cart drawer structure (.minicart_item li)
      var $row = $('.ajaxcart__row[data-line="' + line + '"]');
      if ($row.length === 0) {
        // Try cart drawer structure - find the li that contains the remove button with matching data-line
        var $removeBtn = $('.remove-product[data-line="' + line + '"]');
        if ($removeBtn.length > 0) {
          // First try closest li (most common case)
          $row = $removeBtn.closest('li');
          // If not found, try finding within minicart_item ol
          if ($row.length === 0) {
            $row = $removeBtn.closest('.minicart_item').find('li');
          }
          // If still not found, try any ol parent
          if ($row.length === 0) {
            $row = $removeBtn.closest('ol').find('li');
          }
          // Last resort: find any parent li
          if ($row.length === 0) {
            $row = $removeBtn.parents('li').first();
          }
        }
      }
      
      if ($row.length > 0) {
        $row.addClass('is-loading');
      }

      if (qty === 0) {
        if ($row.length > 0) {
          $row.addClass('is-removed');
          // Always fade out the item being removed
          $row.fadeOut(200);
        }
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Update cart drawer total - always use shop's money format
    var moneyFormat = tcnAjaxCartMoneyFormat();
    var formattedTotal = Shopify.formatMoney(cart.total_price, moneyFormat);
if (cart.item_count > 0) {
      $('#cartDrawerTotalPrice').html(formattedTotal);
    } else {
      // If cart is empty, update total to zero
      $('#cartDrawerTotalPrice').html(Shopify.formatMoney(0, moneyFormat));
    }

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
        
        // Update pricing if updatePricingQty function exists and Currency is available
        // Wrap in try-catch to prevent errors if Currency is not defined
        try {
          if (typeof updatePricingQty === 'function') {
            updatePricingQty(qty);
          }
        } catch (e) {
          // Silently fail if Currency is not available - quantity input still works
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('updatePricingQty failed (Currency may not be available):', e.message);
          }
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  // Expose buildCart globally so it can be called from fallback code
  window.buildCart = buildCart;
  window.cartUpdateCallback = cartUpdateCallback;

  // Set up remove handlers immediately (not just in init) to ensure they're always available
  // This ensures remove functionality works even if ajaxCart.init() hasn't been called yet
  // Use a global handler that can access module functions via closures
  (function() {
    // Check if handlers are already set up to avoid duplicates
    if (window._removeHandlersSetup) {
      return;
    }
    
    /**
     * Remove item handler with event delegation
     * Works for dynamically injected drawer markup and on /cart page
     */
    function handleRemoveItemGlobal(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      var $el = $(this);
      
      // Get line number from data-line attribute (try multiple methods)
      var line = $el.attr('data-line');
      if (!line) {
        line = $el.data('line');
      }
      if (!line) {
        // Try to get from parent elements
        line = $el.closest('li').attr('data-line') || $el.closest('li').data('line');
      }
      // Try to get from href if it's a cart page link
      if (!line && $el.attr('href')) {
        var hrefMatch = $el.attr('href').match(/line=(\d+)/);
        if (hrefMatch) {
          line = hrefMatch[1];
        }
      }
      
      // Convert to number if it's a string
      if (line) {
        line = parseInt(line, 10);
        if (!isNaN(line) && line > 0) {

          // Find the row to fade out - try multiple selectors
          var $row = $el.closest('li');
          if ($row.length === 0) {
            $row = $('.remove-product[data-line="' + line + '"]').closest('li');
          }
          if ($row.length === 0) {
            $row = $('.remove-product[data-line="' + line + '"]').closest('.minicart_item li');
          }
          if ($row.length === 0) {
            $row = $el.closest('.minicart_item').find('li');
          }
          
          // Add loading state
          if ($row.length > 0) {
            $row.addClass('is-loading is-removed');
            $row.fadeOut(200);

          } else {
            console.warn('Could not find row to fade out for line:', line);
          }
          
          // Use fetch API to remove item (works on /cart page too)
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              line: line,
              quantity: 0
            })
          })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Failed to remove item: ' + response.status);
            }
            return response.json();
          })
          .then(function(cart) {

            // Update cart count and total
            if (typeof updateCountPrice === 'function') {
              updateCountPrice(cart);
            }
            
            // Update cart drawer total - always use shop's money format
            var moneyFormat = tcnAjaxCartMoneyFormat();
            var formattedTotal = Shopify.formatMoney(cart.total_price, moneyFormat);
if (cart.item_count > 0) {
              $('#cartDrawerTotalPrice').html(formattedTotal);
            } else {
              $('#cartDrawerTotalPrice').html(Shopify.formatMoney(0, moneyFormat));
              // Hide the recently added item section if cart is empty
              $('#cartDrawerItem').hide();
              $('#cartDrawerTitle').text('Cart');
            }
            
            // Reload cart drawer contents - prioritize window.buildCart
            // Use a small delay to ensure DOM is ready
            setTimeout(function() {
              if (typeof window.buildCart === 'function') {

                window.buildCart(cart);
              } else if (typeof buildCart === 'function') {

                buildCart(cart);
              } else if (typeof ajaxCart !== 'undefined' && ajaxCart.buildCart) {

                ajaxCart.buildCart(cart);
              } else {

                // Fallback: reload the cart via ShopifyAPI
                if (typeof ShopifyAPI !== 'undefined' && ShopifyAPI.getCart) {
                  ShopifyAPI.getCart(function(updatedCart) {
                    if (typeof window.buildCart === 'function') {
                      window.buildCart(updatedCart);
                    } else if (typeof buildCart === 'function') {
                      buildCart(updatedCart);
                    } else if (typeof ajaxCart !== 'undefined' && ajaxCart.buildCart) {
                      ajaxCart.buildCart(updatedCart);
                    }
                  });
                }
              }
            }, 100);
            
            // If on /cart page, reload the page to update the cart table
            if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
              setTimeout(function() {
                window.location.reload();
              }, 300);
            }
          })
          .catch(function(error) {
            console.error('Error removing item:', error);
            // Restore row if error
            if ($row.length > 0) {
              $row.removeClass('is-loading is-removed').show();
            }
          });
        } else {
          console.warn('Invalid line number for remove:', line, $el);
        }
      } else {
        console.warn('No line number found on remove button:', $el);
      }
      
      return false;
    }
    
    // Set up handlers immediately (not waiting for DOM ready)
    // Use event delegation on document to catch dynamically added elements
    // This ensures it works even after drawer content is re-rendered via AJAX
    $(document).off('click.removeHandler', '.remove-product').on('click.removeHandler', '.remove-product', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleRemoveItemGlobal.call(this, e);
      return false;
    });
    
    // Also handle clicks on the icon inside the remove button
    $(document).off('click.removeHandler', '.remove-product i, .remove-product .fa-times').on('click.removeHandler', '.remove-product i, .remove-product .fa-times', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Trigger click on parent remove-product link
      var $parent = $(this).closest('.remove-product');
      if ($parent.length > 0) {
        handleRemoveItemGlobal.call($parent[0], e);
      }
      return false;
    });
    
    // Also handle clicks on the remove-text span (child element)
    $(document).off('click.removeHandler', '.remove-text').on('click.removeHandler', '.remove-text', function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Trigger click on parent remove-product link
      var $parent = $(this).closest('.remove-product');
      if ($parent.length > 0) {
        handleRemoveItemGlobal.call($parent[0], e);
      }
      return false;
    });
    
    // Also handle touch events for mobile
    $(document).off('touchend.removeHandler', '.remove-product').on('touchend.removeHandler', '.remove-product', function(e) {
      e.preventDefault();
      e.stopPropagation();
      handleRemoveItemGlobal.call(this, e);
      return false;
    });
    
    window._removeHandlersSetup = true;

    // Also set up handlers when DOM is ready as a backup
    // Set up handlers immediately when DOM is ready
    $(function() {
      // Re-bind handlers to ensure they're active - use higher priority
      $(document).off('click.removeHandlerBackup', '.remove-product').on('click.removeHandlerBackup', '.remove-product', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        handleRemoveItemGlobal.call(this, e);
        return false;
      });
      
      // Also handle icon clicks - with higher priority
      $(document).off('click.removeHandlerBackup', '.remove-product i, .remove-product .fa-times').on('click.removeHandlerBackup', '.remove-product i, .remove-product .fa-times', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var $parent = $(this).closest('.remove-product');
        if ($parent.length > 0) {
          handleRemoveItemGlobal.call($parent[0], e);
        }
        return false;
      });
      
      // Also handle clicks on the anchor itself (not just the icon)
      $(document).off('click.removeHandlerBackup', 'a.remove-product').on('click.removeHandlerBackup', 'a.remove-product', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        handleRemoveItemGlobal.call(this, e);
        return false;
      });
    });
  })();

  module = {
    init: init,
    load: loadCart,
    loadCart: loadCart,
    buildCart: buildCart
  };

  // Ensure buildCart is always available globally, even if module isn't used
  if (typeof window.buildCart === 'undefined') {
    window.buildCart = buildCart;
  }
  if (typeof window.cartUpdateCallback === 'undefined') {
    window.cartUpdateCallback = cartUpdateCallback;
  }

  return module;

}(ajaxCart || {}, jQuery));
